import { render, staticRenderFns } from "./PersonalIncomeStatement.vue?vue&type=template&id=f5c9a3a4"
import script from "./PersonalIncomeStatement.vue?vue&type=script&lang=js"
export * from "./PersonalIncomeStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports